import React, { useState, useEffect, useContext } from 'react';

import CardDastgahEjraee from './CardDastgahEjraee.tsx';
import T2treeDE from '../treeview/DastgahEjraeT2tree.js';
import T2treeMT from '../treeview/MarjaeTasvibT2tree.js';
import BG from '../../../images/image/footer-background7.png';
import { DataContext } from '../../../context/DataProvider.tsx';

const Test = () => {
  const {
    isTokenExpired,
    tokenLogin,
    fetchRefreshToken,
    toggleSabt,
    setToggleSabt,
    titExecutive,
    setTitExecutive,
    executivSectionText,
    setExecutivSectionText,
    statusExeAndApr,
    setStatusExeAndApr,
    toggleDToM,
    setToggleDToM,
  } = useContext(DataContext);

  useEffect(() => {
    window.scrollTo(0, 0);

    {
      toggleDToM
        ? (document.title = 'عناوین  دستگاه های اجرایی')
        : (document.title = 'عناوین  مراجع تصویب');
    }

    return () => {};
  }, []);

  const CalToggleMToD = () => {
    setToggleDToM(true);
    try {
      setTitExecutive((prev) => ({
        ...prev,
        ID: 0,
        Parent_ID: 0,
        Title: '',
        CreateDate: '',
        ExpireDate: '',
        IsCategory: false,
        State_ID: null,
        isForign: false,
        Domain: '',
        PrevOrg_ID: 0,
        Comment: '',
        IsExecutor: false,
        inActive: false,
      }));
      setExecutivSectionText([]);
    } catch (error) {
      console.log('error', error);
    }
  };

  const CalToggleDToM = () => {
    setToggleDToM(false);
    try {
      setTitExecutive((prev) => ({
        ...prev,
        ID: 0,
        Parent_ID: 0,
        Title: '',
        CreateDate: '',
        ExpireDate: '',
        IsCategory: false,
        State_ID: null,
        isForign: false,
        Domain: '',
        PrevOrg_ID: 0,
        Comment: '',
        IsExecutor: false,
        inActive: false,
      }));
      setExecutivSectionText([]);
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div className=" container px-4 font-IranSans">
      <div
        dir="rtl"
        //  className="grid grid-cols-1 mySize:grid-cols-5 gap-4"
        className="grid grid-cols-12 gap-4 "
      >
        <div
          id="filter-sidebar"
          className=" bg-white block border relative rounded-md duration-300 border-gray-300 col-span-12 lg:col-span-3  p-4 shadow-sm h-[750px]  "
        >
          <div className="flex">
            <div
              className=" relative text-center my-5 rounded-xl flex items-center justify-center font-bold w-full p-3 
                     align-icon cursor-pointer "
              onClick={CalToggleMToD}
            >
              <div className="w-full bg-[#96a6ee] py-4  rounded-lg absolute"></div>
              <p className="absolute text-white  text-wrap w-full text-center text-[14px] ">
                دستگاه های اجرایی{' '}
              </p>
            </div>
            <div
              className=" relative text-center my-5 rounded-xl flex items-center justify-center font-bold w-full p-3 
                     align-icon cursor-pointer "
              // onClick={() => setOpen(!open)}
              onClick={CalToggleDToM}
            >
              <div className="w-full bg-[#80cfae] py-4  rounded-lg absolute"></div>
              <p className="absolute text-white  text-wrap w-full text-center text-[14px] ">
                مراجع تصویب{' '}
              </p>
            </div>
          </div>
          {/* <hr /> */}
          {toggleDToM ? (
            <div className="h-5/6 overflow-auto mt-10">
              <T2treeDE />
            </div>
          ) : (
            <div className="h-5/6 overflow-auto mt-10">
              <T2treeMT />
            </div>
          )}
        </div>

        <div
          id="card-filter"
          className="bg-white shadow-md rounded-md px-4 pt-6 pb-2 border border-gray-300 col-span-12 lg:col-span-9 "
          // className="bg-white shadow-md rounded-md px-4 pt-6 pb-20 border border-gray-300 col-span-5 mySize:col-span-7 "
        >
          <div className="flex justify-center mt-1 "></div>

          <CardDastgahEjraee />
        </div>
      </div>
    </div>
  );
};

export default Test;
